import React, { useMemo, useState } from 'react';
import { Input } from '../../../../common/Forms/Input/Input';
import useCampaignGeneralSettings from '../../../../../hooks/params/useCampaignGeneralSettings';
import DefaultSettingsTable from './DefaultSettingsTable';
import './DefaultSettings.scss';

const formatDisplayDate = (date) => {
  if (!date) return '--/--/----';

  const sourceDate = date instanceof Date ? date : new Date(date);

  if (Number.isNaN(sourceDate.getTime())) return '--/--/----';

  return sourceDate.toLocaleDateString('es-VE');
};

const formatUserName = (user) => {
  if (!user) return;

  return [user.firstName, user.lastName].filter(Boolean).join(' ') || '';
};

export default function DefaultSettingSection() {
  const {
    register,
    errors,
    currentConfig,
    historyData,
    isSaving,
    onSubmit,
    handleHistoryPageChange,
    onHistoryLimitChange,
    control,
  } = useCampaignGeneralSettings();
  const [showHistory, setShowHistory] = useState(true);

  const indicatorDays = useMemo(() => {
    return Number(currentConfig?.activationDays ?? 0);
  }, [currentConfig?.activationDays]);

  return (
    <section className="default-settings-section">
      <div className="default-settings-section__shell">
        <div className="default-settings-section__top-panel">
          <div className="default-settings-section__indicator-panel">
            <span className="default-settings-section__eyebrow">
              CONFIGURACION GENERAL
            </span>
            <div className="default-settings-section__indicator-row">
              <div className="default-settings-section__indicator-value">
                {indicatorDays}
              </div>
              <div className="default-settings-section__indicator-copy">
                <h2>días desde la compra</h2>
                <p>
                  Valor tomado en cuenta desde el{' '}
                  {formatDisplayDate(currentConfig?.beginDate || new Date())}
                </p>
                <span>{formatUserName(currentConfig?.updatedBy || currentConfig?.createdBy)}</span>
              </div>
            </div>
          </div>

          <div className="default-settings-section__form-panel">
            <span className="default-settings-section__panel-title">
              Programar cambio global
            </span>

            <form className="default-settings-section__form" onSubmit={onSubmit}>
              <div className="default-settings-section__form-fields">
                <div className="default-settings-section__field default-settings-section__field--date">
                  <Input
                    label="A partir de"
                    type="date"
                    name="beginDate"
                    control={control}
                    register={register}
                    errors={errors?.beginDate?.message}
                    minDate={new Date()}
                  />
                </div>

                <div className="default-settings-section__field default-settings-section__field--days">
                  <Input
                    label="Nuevo valor (días)"
                    type="number"
                    name="activationDays"
                    register={register}
                    errors={errors?.activationDays?.message}
                    placeholder="0"
                  />
                </div>

                <button
                  type="submit"
                  className="default-settings-section__submit"
                  disabled={isSaving}
                >
                  {isSaving ? 'Guardando...' : 'Programar'}
                </button>
              </div>
            </form>
          </div>
        </div>

        <div className="default-settings-section__history-panel">
          <div className="default-settings-section__history-header">
            <h3>Historial de cambios globales</h3>

            <button
              type="button"
              className="default-settings-section__toggle-history"
              onClick={() => setShowHistory((prev) => !prev)}
            >
              {showHistory ? 'Ocultar historia' : 'Mostrar historia'}
              <span>{showHistory ? '▲' : '▼'}</span>
            </button>
          </div>

          {showHistory && (
            <DefaultSettingsTable
              data={historyData.data}
              total={historyData.total}
              limit={historyData.limit}
              offset={historyData.offset}
              isLoading={historyData.isLoading}
              onPageChange={handleHistoryPageChange}
              onLimitChange={onHistoryLimitChange}
            />
          )}
        </div>
      </div>
    </section>
  );
}
